<template>
  <div
    class="service_card_main"
    :class="{'en-service-main': isEnglish}"
  >
    <service-card>
      <template v-slot:price>
        <h2
          class="price"
        >
          0
        </h2>
      </template>
      <template slot="list">
        <ul class="service_list">
          <li><li-icon /><span>{{ memberNumTip[0] }}</span>{{ memberNumTip[1] }}</li>
          <li><li-icon /><span>{{ infoNumber[0] }}</span>{{ infoNumber[1] }}</li>
          <li><li-icon /><span>{{ $t('message["1135"]') }}</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["1258"]') }}</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["1663"]') }}logo</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["558"]') }}</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["711"]') }}</span></li>
        </ul>
        <span class="s-i-btn s-i-cur-btn">{{ $t('message["157"]') }}</span>
      </template>
    </service-card>
    <service-card
      :title="advanceTit"
      :is-advanced="true"
    >
      <template v-slot:price>
        <h2 class="price">
          440
        </h2>
      </template>
      <!-- <template v-slot:header>
        <p class="service_unit_price">
          年付440元/人
        </p>
      </template> -->
      <template v-slot:list>
        <ul class="service_list">
          <li><li-icon /><span>{{ $t('message["1322"]') }}）</span></li>
          <li><li-icon /><span>{{ $t('message["630"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["1134"]') }}）</span></li>
          <li><li-icon /><span>{{ $t('message["1258"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["1663"]') }}logo</span></li>
          <li><li-icon /><span>{{ $t('message["558"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["711"]') }}</span></li>
        </ul>
        <router-link
          v-if="!$isDingDing"
          class="s-i-btn s-i-advanced-btn"
          :to="{ name: 'ServiceBuy', query: {type: 3}}"
        >
          {{ $t('message["599"]') }}
        </router-link>
        <ding-tip
          v-else
          type="upgrade"
        />
      </template>
    </service-card>
  </div>
</template>

<script type="text/ecmascript-6">
import liIcon from './components/SvgLi'
import ServiceCard from './components/ServiceCard'
import { mapActions } from 'vuex'
import i18n from '@/lib/language'
import { getLang } from '@/lib/storage'
import DingTip from '@/components/pc/serviceup/DingTip'

const CRUMB_TITLE = i18n.t('message["312"]')
export default {
  components: {
    liIcon,
    ServiceCard,
    DingTip
  },
  data () {
    return {
    }
  },
  computed: {
    advanceTit () {
      return this.$t('message["351"]')
    },
    memberNumTip () {
      return this.$t('message["1321"]').split('|')
    },
    infoNumber () {
      return this.$t('message["629"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setCrumbLabel(CRUMB_TITLE)
    })
  },
  methods: {
    ...mapActions('config/service', ['setCrumbLabel']),
    getLang
  }
}
</script>

<style scoped lang="scss">
.service_card_main {
  display: flex;
  flex-direction: row
}
.en-service-main {
  height: auto !important;
  .service_list {
    width: 265px;
    position: static;
    margin: 35px auto 0;
    li {
      position: relative;
      padding-left: 24px;
      line-height: 22px;
      svg{
        position: absolute;
        left: 0;
        width: 16px;
        height: 16px;
        top: 4px;
      }
      span {
        margin-left: 0;
      }
    }
  }
  .s-i-btn {
    transform: translateX(0);
    margin: 30px auto 35px;
    position: static;
    display: block;
  }
}
</style>
